import Vue from 'vue'
import router, { addRoutes } from '@/router'
import store from '@/store'
import i18n from '@/i18n'
import App from '@/App.vue'
import compsIndexes from '@/router/compsIndexes'
import { init } from '@/main.base'

init()
addRoutes(compsIndexes)

window.$vue = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js